import { Feed } from "feed";
import { set_size } from "../getImageToDisplay";
import { titlePrefix, titleSuffix } from "../BuildUrl/buildTitleAnnonce";
import { fix_type } from "pagesHelpers/ListingPagesHepler/ListingPagesHelperWrapper";
import formatUrl from "../FormatUrl";
import { buildListingUrl } from "components/v2/Listings/ListingsRouterUrlHelper";
import {
  buildDescriptionListingPage,
  buildPageTitle,
  formatNumberWithContext,
  getSurface,
  match_bien_types_neufs,
  pluralOf,
} from "pagesHelpers/ListingPagesHepler/HeadSeoHelper";
import { title } from "process";
var regex = /(<([^>]+)>)/gi;

export const buildListingTitle = (
  listing,
  t = (e) => {
    return e;
  },
  lang = "fr"
) => {
  let title = "";
  title = `${listing.projectName ? `${listing.projectName} - ` : ""}${
    listing ? t(listing.type) : listing.type ? t(listing.type) : ""
  } ${listing.transaction_type == "Location" ? t("à louer") : t("à vendre")}${
    listing.prix
      ? ` ${formatNumberWithContext(
          Math.floor(listing.prix),
          lang == "ar"
        )} ${t("dh")} `
      : ""
  }${
    listing
      ? `${getSurface(listing)
          .toString()
          .replace(/(.)(?=(\d{3})+$)/g, "$1 ")} ${t("m²")}`
      : ""
  }${
    listing
      ? `${
          listing?.type === "Terrain"
            ? ""
            : listing?.typologie <= 1
            ? listing?.type === "Bureau" || listing?.type === "Commerce"
              ? listing?.typologie
                ? t(` avec ${listing?.typologie} pièce`)
                : ""
              : t(` avec ${listing?.typologie} chambre`)
            : listing?.type === "Bureau" || listing?.type === "Commerce"
            ? listing?.typologie
              ? t(` avec ${listing?.typologie} pièces`)
              : ""
            : `${t(" avec")} ${listing?.typologie} ${t("chambres")}`
        } - `
      : ""
  }${
    listing.quartier
      ? `${t(listing.quartier)} `
      : listing.commune
      ? `${t(listing.commune)} `
      : ""
  }${
    listing.province
      ? t(`${listing.province}`)
      : listing.region
      ? t(`${listing.region}`)
      : ""
  } | ${t("Agenz")}`;

  title = title.replace(regex, "");
  return title;
};

export const buildListingDescriptionSEO = (listing) => {
  return `${listing.type} de ${listing.typologie} ${
    listing.typologie > 1 ? "chambres" : "chambre"
  } avec une superficie de ${listing.surface} mètres carrés et ${
    listing.sdb
  } salles de bain à ${
    listing.transaction_type === "Vente" ? "vendre" : "louer"
  } à ${listing.province}, ${listing.commune}, dans le quartier de ${
    listing.quartier
  }. Prix : ${listing.prix.toString().replace(/(.)(?=(\d{3})+$)/g, "$1 ")} MAD`;
};
export const generateRssFeed = async (
  listings,
  url = null,
  transaction_type: any = "Vente",
  type = ["Appartement"],
  province = "",
  commune = "",
  quartier = "",
  titleComplement = "",
  region = ""
) => {
  const feed = new Feed({
    title: buildPageTitle(
      transaction_type,
      type,
      region,
      province,
      commune,
      quartier,
      titleComplement,
      1
    ),

    description: buildDescriptionListingPage(
      transaction_type,
      typeof type == "string" ? type : type[0],
      region,
      province,
      commune,
      quartier,
      titleComplement,
      1
    ),
    id: url
      ? `https://agenz.ma${formatUrl(url.replace("/feed/", "/"), "fr")}`
      : "https://agenz.ma",
    link: url
      ? `https://agenz.ma${formatUrl(url.replace("/feed/", "/"), "fr")}`
      : "https://agenz.ma",
    language: "fr",
    image: "https://images.agenz.ma/uploads/agenz-logo_250x250.webp",
    favicon: "https://agenz.ma/favicon.ico",
    copyright: `All rights reserved ${new Date().getFullYear()}, agenz.ma `,
    author: {
      name: "Agenz maroc",
      email: "contact@agenz.ma",
      link: "https://agenz.ma",
    },
  });

  listings?.forEach((listing) => {
    feed.addItem({
      title: buildListingTitle(listing),
      id: listing.slug_id,
      link: `https://agenz.ma${buildListingUrl(listing)}`,
      description: listing.Description
        ? listing.Description.length > 50
          ? listing.Description
          : buildListingDescriptionSEO(listing)
        : buildListingDescriptionSEO(listing),
      content: listing.Description ? listing.Description : null,
      date: new Date(listing.date),
      image: set_size(listing.images, "1080x750", "webp"),
    });
  });

  feed.addCategory(
    `${titlePrefix(transaction_type, type, (e) => {
      return e;
    })} ${titleSuffix(
      region ?? "",
      province ?? "",
      "",
      (e) => {
        return e;
      },
      quartier ? quartier : "",
      titleComplement,
      ""
    )}`
  );

  return feed.rss2();
};
